import useCachedQuery from '~/app/shared/hooks/useCachedQuery';
import useQuery from '~/app/shared/hooks/useQuery';
import { AccountingRules, ProductGroup, VatZone } from '~/types/internal-api';

export default function useCompanyGroupCountrySpecificVatRules(): [
    (pGroup: Partial<ProductGroup> | undefined) => Partial<ProductGroup> | undefined,
    boolean,
    VatZone[],
] {
    const showCountrySpecificFeatures = useQuery<boolean>('/vat/show-country-specific-vat-features', false).data;
    const countrySpecificVatZones = useCachedQuery<VatZone[]>('/vat/zones-country-specific', []).data;

    const appendCountrySpecificVatRules = (pGroup: Partial<ProductGroup> | undefined) => {
        if (!showCountrySpecificFeatures) {
            return pGroup;
        }

        if (!pGroup) {
            pGroup = {} as ProductGroup;
        }

        const countrySpecificVatRules = getCountrySpecificVatRules(pGroup);
        if (!pGroup.accountingRules) {
            pGroup.accountingRules = {} as AccountingRules;
        }
        pGroup.accountingRules.countrySpecificVatRuleItems = countrySpecificVatRules;

        return pGroup;
    };

    const getCountrySpecificVatRules = (productGroup: Partial<ProductGroup>) => {
        if (!countrySpecificVatZones || countrySpecificVatZones.length === 0) {
            return;
        }

        return countrySpecificVatZones.map(item => {
            const ruleItem = productGroup.accountingRules?.countrySpecificVatRuleItems?.find(p => p.zoneId === item.number);
            return {
                zoneId: item.number,
                name: item.name,
                accountNumber: ruleItem?.accountNumber!,
                textId: item.textId,
            };
        });
    };

    return [appendCountrySpecificVatRules, showCountrySpecificFeatures, countrySpecificVatZones];
}
